<template>
    <article
        v-if="fixedNew"
        class="a-news-item a-news-item--fixed-new text-white">
            <picture-helper
                :image-data="bgImage" />
            <div class="a-news-item__container">
                <div class="a-news-item__sub">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8 0L4 14H10V24H0V14L4 0H8Z" fill="white"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M22 0L18 14H24V24H14V14L18 0H22Z" fill="white"/>
                    </svg>
                </div>
                <h3 class="a-news-item__title">
                    {{ fixedNew.detail_text }}
                </h3>
                <div class="a-news-item__desc-wrap">
                    <div class="a-news-item__photo">
                        <img
                            :src="fixedNew.picture.src"
                            :alt="fixedNew.name"
                            :title="fixedNew.name"
                            :width="fixedNew.picture.width"
                            :height="fixedNew.picture.height" />
                    </div>
                    <div class="a-news-item__text-wrap">
                        <span class="a-news-item__name">
                            {{ fixedNew.name }}
                        </span>
                        <span
                            v-html="fixedNew.preview_text"
                            class="a-news-item__position"></span>
                    </div>
                </div>
            </div>
    </article>
    <article
        v-for="newItem in itemsData.data"
        :key="newItem.id"
        class="a-news-item"
        :class="newItem.textColor === 'white' ? 'text-white' : ''">
        <a
            class="a-news-item__link"
            :href="newItem.detail_page_url"
            :title="newItem.name"
            :target="newItem.target ? newItem.target : ''">
            <div class="a-news-item__container">
                <div class="a-news-item__wrapper">
                    <div
                        v-if="newItem.sub"
                        class="a-news-item__sub">
                        {{ newItem.sub }}
                    </div>
                    <h3 v-html="newItem.name" class="a-news-item__title"></h3>
                </div>
                <div class="a-news-item__wrapper">
                    <div
                        v-if="newItem.active_from"
                        class="a-news-item__date">
                        <span class="a-news-item__day">
                            {{ newItem.active_from.split('.')[0] }}
                        </span>
                        /
                        <span class="a-news-item__month">
                            &nbsp;{{ monthes[newItem.active_from.split('.')[1] - 1] }}
                        </span>
                    </div>
                    <div
                        v-if="newItem.props"
                        class="a-news-item__image">
                        <img 
                            :src="newItem.props['smi-data'].src"
                            :title="newItem.props['smi-data'].name"
                            :alt="newItem.props['smi-data'].name"
                            width="44"
                            height="44" />
                    </div>
                </div>
            </div>
        </a>
    </article>
</template>

<script>
    import PictureHelper from './helpers/PictureHelper'

    export default {
        name: 'NewsItem',
        props: {
            itemsData: Object,
            fixedNew: Object
        },
        components: {
            PictureHelper
        },
        data() {
            return {
                monthes: [
                    'января',
                    'февраля',
                    'марта',
                    'апреля',
                    'мая',
                    'июня',
                    'июля',
                    'августа',
                    'сентября',
                    'октября',
                    'ноября',
                    'декабря'
                ],

                bgImage: {
                    src: '/static/v2/src/img/analytics/all-study/news',
                    width: '360',
                    height: '268',
                    alt: 'Запуски новых проектов многоквартирного жилья в РФ'
                },

            }
        },
    }
</script>